import React, { memo } from 'react';
import PropTypes from 'prop-types';

const LogisticsTableMobile = ({ logistics }) => {
  return (
    <div className="cases-table-mobile">
      {logistics.map((logistics) => {
        return (
          <div key={logistics.id} className="case-mobile-row">
            <div className="d-flex space-between m-t-sm">
              <div className="m-r-md flex-1">{logistics.name}</div>
            </div>
            <div className="d-flex space-between m-t-sm">
              <div className="secondary">
                {logistics.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

LogisticsTableMobile.propTypes = {
  logistics: PropTypes.array,
};

export default memo(LogisticsTableMobile);
